// Slice where the loading state is

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchOperations } from "./globalApi";

export const initialState = {
  loading: true,
  showOperationsPanel: false,
  blockApp: false,
  blockAppMessage: "",
  operations: []
};

export const loadOperations = createAsyncThunk(
  'auth/loadOperations',
  async (_,thunkAPI) => {
      const response = await fetchOperations();
      if (response?.success) {
          return response.data
      } else {
          return response?.error
      }
  }
);

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAppBlock: (state, action) => {
      state.blockApp = action.payload.block;
      state.blockAppMessage = action.payload.message;
    },
  },
  extraReducers: (builder) => {
    builder
        .addCase(loadOperations.fulfilled, (state, action) => {
            state.operations=action?.payload?.operations
        })
    }
});

export const { setLoading, setAppBlock } = globalSlice.actions;

export default globalSlice.reducer;

export const selectLoadingState = (state) => state.global.loading; 
export const selectShowOperationsPanel = (state) => state.global.showOperationsPanel; 
export const selectOperations = (state) => state.global.operations; 
export const selectBlockApp = (state) => state.global.blockApp
export const selectBlockAppMessage = (state) => state.global.blockAppMessage